module.exports = __webpack_public_path__ + "img/admin.36fe1216.svg";